import { Flex, Text } from "@chakra-ui/react";
import { textPrimary, textSecondary } from "../../../../../utils/colors";
import { useTranslation } from "react-i18next";
import PinCodeInputs from "../../../../../components/input/PinCodeInputs";
// import { debounce } from "lodash";

const PatientPortalVerifyAccess = ({
  onVerify,
  pinCode,
  setPinCode,
  email,
}) => {
  const { t } = useTranslation();

  const handlePinComplete = (enteredPin) => {
    setPinCode(enteredPin); // ✅ Store the full PIN
  };

  const handleVerify = () => {
    if (pinCode.length === 4) {
      onVerify(pinCode); // ✅ Pass the PIN properly
    }
  };

  return (
    <Flex w="100%" direction="column" align="center" m="1.5rem auto 0">
      <Text
        fontSize={["md", "15px"]}
        color={textSecondary}
        fontWeight="500"
        m="0 auto 1.5rem"
        textAlign={["left", "center"]}
      >
        {t("patient.patientPortalEnterPin")}
        <Text as="span" color={textPrimary} fontWeight="500" ml={1}>
          {email}
        </Text>
      </Text>
      <Flex
        justify={["flex-start", "center"]}
        align="center"
        w="100%"
        maxW={["100%", "300px"]}
        m="0 auto"
      >
        <PinCodeInputs
          length={4}
          onComplete={handlePinComplete}
          onVerify={handleVerify}
          pinCode={pinCode}
          setPinCode={setPinCode}
        />
      </Flex>
    </Flex>
  );
};

export default PatientPortalVerifyAccess;
